import PageAnimations, { Animations } from 'animations';

if (!customElements.get('recently-viewed')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super(), (this.fetch_delay = 0);
    }

    connectedCallback() {
      this.handle = this.dataset.productHandle;
      this.id = this.dataset.productId;
      this.onPageLoad = this.hasAttribute('on-page-load');
      this.productLimit = Number(this.dataset.productLimit);

      this.fetchRecentlyViewedProducts();
    }

    /**
     * Adds a product to the recently viewed products in the session storage
     * 
     * @param {string} productHandle - The product handle
     * @param {string} productId - The product id
     */
    addRecentlyViewedProduct(productHandle, productId) {
      const productIndentifier = `${productHandle}:${productId}`;
      const viewedProducts = this.getRecentlyViewedProducts();
      const index = viewedProducts.indexOf(productIndentifier);

      if (index > -1) {
        viewedProducts.splice(index, 1);
      }

      viewedProducts.unshift(productIndentifier);

      sessionStorage.setItem('recently_viewed_products', JSON.stringify(viewedProducts));
    }

    /**
     * Fetches the recently viewed products
     */
    fetchRecentlyViewedProducts() {
      if (this.onPageLoad) {
        this.#displayProducts();

        if (this.handle !== '') {
          this.addRecentlyViewedProduct(this.handle, this.id);
        }
      } else {
        new IntersectionObserver(
          ((e, t) => {
            e.forEach((e) => {
              e.isIntersecting &&
                (t.unobserve(this),
                (this.fetch_delay = Number(
                  window.theme?.complementary_products_fetch_delay || '0'
                )),
                setTimeout(() => {
                  this.#displayProducts();
                }, this.fetch_delay));
            });
          }).bind(this),
          { rootMargin: '0px 0px 400px 0px' }
        ).observe(this);
      }
    }

    /**
     * Gets the recently viewed products from the session storage
     * 
     * @returns {Array} The recently viewed products
     */
    getRecentlyViewedProducts() {
      const storedProducts = sessionStorage.getItem('recently_viewed_products');
      let viewedProducts = [];

      if (storedProducts && storedProducts.startsWith('[')) {
        viewedProducts = JSON.parse(storedProducts);
      }

      return viewedProducts;
    }

    async #displayProducts() {
      const viewedProducts = this.getRecentlyViewedProducts();
      const productCards = [];
      let productCardItr = 0;

      for (const productIdentifier of viewedProducts) {
        const productHandle = productIdentifier.split(':')[0];

        if (productHandle === this.handle) {
          continue;
        }

        productCards.push(
          fetch(`${window.Shopify.routes.root}products/${productHandle}?section_id=section-recently-viewed-product-card`)
            .then((response) => response.text())
            .then((data) => {
              return new DOMParser()
                .parseFromString(data, 'text/html')
                .querySelector('.product-card')?.outerHTML;
            })
            .catch((error) => {
              console.error(error);
            })
        );

        productCardItr += 1;

        if (productCardItr >= this.productLimit) {
          break;
        }
      }

      try {
        const recentlyViewedProducts = this.querySelector('.js-recently-viewed-products');
        const results = await Promise.all(productCards);

        if (!!(recentlyViewedProducts)) {
          recentlyViewedProducts.innerHTML = results.join('');
          
          const recentlyViewedProductCards = this.querySelectorAll('.product-card');
          const productCardsArray = Array.from(recentlyViewedProducts.querySelectorAll('.product-card'));
          if (
            (0 === recentlyViewedProductCards.length && 0 === productCardsArray.length
              ? this.setAttribute('hidden', '')
              : this.removeAttribute('hidden'),
            recentlyViewedProductCards.length > 0)
          ) {
            const imageSkeletons = recentlyViewedProducts.querySelectorAll('image-skeleton');
            const animateSequence = recentlyViewedProducts.querySelector('.js-animate-sequence');
            imageSkeletons.forEach((imageSkeleton) => imageSkeleton.setAttribute('loaded', '')),
              Animations.setRevealedState(animateSequence);
          }
          if (
            (recentlyViewedProductCards.length > 0 &&
            productCardsArray.length > 0 &&
            recentlyViewedProductCards.length === productCardsArray.length
              ? recentlyViewedProductCards.forEach(
                  (recentlyViewedProductCard, index) => {
                    const productCard = productCardsArray[index];
                    const productCardLink = productCard.querySelector(
                      "[product-card-link]"
                    );
                    const href = productCardLink.getAttribute("href");
                    recentlyViewedProductCard
                      .querySelectorAll("[product-card-link]")
                      .forEach((recentlyViewedProductCardLink) =>
                        recentlyViewedProductCardLink.setAttribute("href", href)
                      );
                  }
                )
              : (this.querySelector(
                  ".js-recently-viewed-products"
                )?.insertAdjacentHTML(
                  "beforeend",
                  recentlyViewedProducts.innerHTML
                ),
                PageAnimations.setup(this)),
            "true" === this.dataset.quickShopDynamicCheckout)
          ) {
            const e = setInterval(() => {
              window.Shopify.PaymentButton &&
                (window.Shopify.PaymentButton.init(), clearInterval(e));
            }, 50);
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  }

  customElements.define('recently-viewed', RecentlyViewedProducts);
}